module.exports = {"id":"215316","name":"Gerónimo Rulli","rating":"82","photo":"./data/images/photos/2/215316.png","club":{"name":"Real Sociedad","logo":"./data/images/clubs/RealSociedad.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GeronimoRulli0.json
// module id = 1573
// module chunks = 0